import { useCallback, useState } from "react";

export interface TopUpModalController {
  isOpen: boolean;
  selectedCredits: number;
  open: (initialCredits?: number) => void;
  close: () => void;
  setSelectedCredits: (credits: number) => void;
}

export function useTopUpModal(initialCredits = 10): TopUpModalController {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCredits, setSelectedCredits] = useState(initialCredits);

  const open = useCallback((credits?: number) => {
    if (typeof credits === "number" && credits > 0) {
      setSelectedCredits(credits);
    }
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    selectedCredits,
    open,
    close,
    setSelectedCredits
  };
}
